<template>
  <div class="pay_loading_content">
    <div class="pay_loading"></div>
  </div>
  <van-overlay :show="show" @click="show = true">
    <div class="wrapper">
      <van-loading size="24px">支付跳转中，请稍后...</van-loading>
    </div>
  </van-overlay>
  <!-- 配置文本 -->
  <form action="https://sis-t.redsys.es:25443/sis/realizarPago" method="post">
    <input
      type="hidden"
      id="Ds_SignatureVersion"
      name="Ds_SignatureVersion"
      v-model="params.version"
    />
    <br />
    <input
      size="100"
      type="hidden"
      id="Ds_MerchantParameters"
      name="Ds_MerchantParameters"
      v-model="params.parms"
    />
    <br />
    <input
      type="hidden"
      size="50"
      id="Ds_Signature"
      name="Ds_Signature"
      v-model="params.sig"
    /><br />
    <!-- <el-button type="primary" size="large" @click="InitiatePay()">  支付
    </el-button> -->
    <button class="submitPlain" type="submit" id="submitPlain">支付</button>
  </form>
</template>
<script>
import axios from "../../commons/AxiosMethod.js"
export default {
  name: "header",
  data () {
    return {
      params: {},
      PayParams: [],
      OrderId: "", // 订单号
      show: true
    }
  },
  props: {},
  components: {},
  mounted () {
    this.OrderId = this.$route.query.Id

    this.GetOrder()

    // 这个是页面创建的时候，就执行相关的方法
  },
  methods: {
    // 获取订单的所有信息
    GetOrder () {
      axios.apiMethod(
        "/Orders/Order/GetOrder?Id=" + this.OrderId,
        "get",
        {},
        (result) => {
          if (result.Code == 200) {
            this.OrderModel = result.Data.order
            this.PayParams = result.Data.pay
            this.params = {
              sig: this.PayParams.params["sig"],
              parms: this.PayParams.params["parms"],
              version: this.PayParams.params["version"]
            }

            document.getElementById("Ds_Signature").value =
              this.PayParams.params["sig"]
            document.getElementById("Ds_MerchantParameters").value =
              this.PayParams.params["parms"]
            document.getElementById("Ds_SignatureVersion").value =
              this.PayParams.params["version"]
            document.getElementById("submitPlain").click()
          } else {
            showToast(result.Msg)
          }
        },
        (e) => {}
      )
    }
  }
}
</script>
<style  lang="scss"  scoped>
.submitPlain {
  display: none;
}
.pay_loading_content {
  width: 100%;
  text-align: center;
  .pay_loading {
    margin-top: 60px;
    margin: 0 auto;
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>

